import type { ProductAd, ProductAdsAPIResponse } from '@/scopes/product-ads/domain/types';

export interface ProductAdsMapper {
  map: (apiResponse?: ProductAdsAPIResponse) => ProductAd[];
}

export const createProductAdsMapper: () => ProductAdsMapper = () => {
  const map = (apiResponse?: ProductAdsAPIResponse): ProductAd[] => {
    if (!apiResponse?.data) {
      return [];
    }

    if (!apiResponse.data[0].ads) {
      return [];
    }

    const ads: ProductAd[] = apiResponse.data[0].ads.map((ad) => ({
      adId: ad.adId,
      flightId: ad.flightId,
      priorityId: ad.priorityId,
      rendered: ad.impressionUrl,
      viewed: ad.viewableImpressionUrl,
      clicked: ad.clickUrl,
      image: ad.contentImage,
      heading: ad.contentHeading,
      subHeading: ad.contentSubheading,
      accoId: ad.contentAccoId,
      logo: ad.contentLogo,
      ...(ad.conversionUrl && { conversionUrl: ad.conversionUrl }),
    }));

    return ads;
  };

  return {
    map,
  };
};
